import { api } from './client'

// FR-28: App settings / white-label
export const getSettings = () =>
  api.get('/settings').then((r) => r.data)

export const updateSettings = (patch) =>
  api.put('/settings', patch).then((r) => r.data)

// The institution's own subscription: tier, expiry, limits and current usage.
// A GET on purpose, so it still answers while the institution is read-only —
// which is exactly when someone needs to see why.
export const getMyPlan = () =>
  api.get('/settings/plan').then((r) => r.data)

// Integrasi Zoom lembaga. Secret tidak pernah dikembalikan server.
export const getZoomStatus = () =>
  api.get('/settings/zoom/status').then((r) => r.data)

export const getZoomSettings = () =>
  api.get('/settings/zoom').then((r) => r.data)

export const saveZoomSettings = (body) =>
  api.put('/settings/zoom', body).then((r) => r.data)

export const testZoomSettings = () =>
  api.post('/settings/zoom/test').then((r) => r.data)

export const deleteZoomSettings = () =>
  api.delete('/settings/zoom').then((r) => r.data)

// Gambar halaman masuk: kind = 'logo' | 'cover' | 'favicon'. Berkasnya disimpan
// dan kolom lembaga langsung diperbarui — tidak menunggu tombol Simpan — lalu
// jawabannya memuat seluruh branding terbaru.
export const uploadBrandingImage = (kind, file, { onProgress, signal } = {}) => {
  const fd = new FormData()
  fd.append('file', file)
  return api
    .post(`/settings/branding/${kind}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      signal,
      onUploadProgress: onProgress ? (e) => onProgress(e.loaded, e.total) : undefined,
    })
    .then((r) => r.data)
}
